import React, { useState } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import { toast } from "react-toastify";
import axios from "axios";

const ReturnCoins = () => {
  const coinData = sessionStorage.getItem("coin");
  const coinDetails = JSON.parse(coinData);
  const [dataDetails, setDataDetails] = useState({
    username: "",
    coins: "",
    senderName: "",
  });
  // console.log(coinDetails);
  // fetch user details
  const checkuser = () => {
    var userId = $("input[name='username']").val();

    $("#form-error1").remove();
    $.ajax({
      url: `${process.env.REACT_APP_BASEURL}/coin/recharge/sendCoinfetchuser`,
      type: "get",
      dataType: "json",
      data: {
        userId,
      },
      success: function (res) {
        if (res.success === 1) {
          if (res.details.username != "") {
            var div = `
                  <div className="form-error1" id="form-error1" style="display:flex; color:gray; margin-top: 15px;">
                    <img src=${res.details.picture} style='border-radius:50% ; height:50px; width:50px;' alt="User Profile" />
                    <span style='margin-left: 15px; '>${res.details.username} <br /> ${res.details.name}</span>
                  </div>
                `;
          }
          $(".form-error4").html("");
          $("#user").append(div);
        } else {
          $(".form-error4").html("no user found");
        }
      },
    });
  };
  const checkCoinPanel = () => {
    var userId = $("input[name='senderName']").val();
    if (userId.startsWith("coin@")) {
      $("#form-error1").remove();
      $.ajax({
        url: `${process.env.REACT_APP_BASEURL}/coin/recharge/sendCoinfetchagency`,
        type: "get",
        dataType: "json",
        data: {
          userId,
        },
        success: function (res) {
          if (res.success === 1) {
            if (res.details.username != "") {
              var div = `
                        <div className="form-error1" id="form-error1" style="display:flex; color:gray; margin-top: 15px;">
                          <img src=${res.details.image} style='border-radius:50% ; height:50px; width:50px;' alt="User Profile" />
                          <span style='margin-left: 15px; '>${res.details.uniqueId} <br /> ${res.details.name}</span>
                        </div>
                      `;
            }
            $(".form-error4").html("");
            $("#coin").append(div);
          } else {
            $(".form-error4").html("no user found");
          }
        },
      });
    }
  };
  const onChangeSubmit = (e) => {
    setDataDetails({ ...dataDetails, [e.target.name]: e.target.value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASEURL1}/admin/return/coins`,
      dataDetails
    );
    // console.log(dataDetails);
    // console.log(data);
    if (data.success == "1") {
      toast.success(data.message);
      // console.log(data);
    }
  };

  return (
    <>
      <section className="content-header">
        <h1>Return Coins</h1>
        <ol className="breadcrumb">
          <li>
            <Link to="/coin/dashboard">
              <i className="fa fa-dashboard"></i> Home
            </Link>
          </li>
          <li className="active">Return Coins</li>
        </ol>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-md-12">
            <form>
              <div className="box box-warning">
                <div className="box-header with-border">
                  <h3 className="box-title">Return</h3>
                </div>
                <div className="box-body">
                  <div className="form-group" id="user">
                    <label>Username*</label>
                    <input
                      type="text"
                      className="form-control"
                      name="username"
                      placeholder="username"
                      onChange={(e) => {
                        $(".form-error4").html("");
                        checkuser();
                        onChangeSubmit(e);
                      }}
                    />
                    <div className="form-error4 text-danger"></div>
                  </div>
                  <div className="form-group" id="coin">
                    <label>Sender Name*</label>
                    <input
                      type="text"
                      className="form-control"
                      name="senderName"
                      placeholder="If admin then type admin or coin panel uniqueId"
                      onChange={(e) => {
                        $(".form-error4").html("");
                        checkCoinPanel();
                        onChangeSubmit(e);
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label>Coins*</label>
                    <input
                      type="text"
                      className="form-control"
                      name="coins"
                      placeholder="Coins"
                      onChange={(e) => {
                        $(".form-error5").html("");
                        onChangeSubmit(e);
                      }}
                    />
                    <div className="form-error5 text-danger"></div>
                  </div>

                  <div className="form-group d-flex justify-content-center">
                    <button type="reset" className="btn btn-danger">
                      Cancel
                    </button>

                    <span onClick={submitHandler}>
                      <input
                        type="submit"
                        className="btn btn-success pull-right"
                        name="submit"
                        defaultValue="Submit"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default ReturnCoins;
